import { jsx as _jsx } from "react/jsx-runtime";
import Skeleton from '@shared/ui/Skeleton';
import styles from './ProjectListSkeleton.module.scss';
export function ProjectListSkeleton() {
    return (_jsx("div", { className: styles.container, children: Array.from({ length: 4 }).map((_, index) => (_jsx(Skeleton, { className: styles.skeleton }, index))) }));
}
